@file:Suppress("MagicNumber", "ForbiddenComment", "UnusedPrivateProperty", "LongParameterList")

package cbconnectit.portfolio.web.styles

import com.materialkobweb.theme.darkColorScheme
import com.materialkobweb.theme.lightColorScheme
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.Palette
import com.varabyte.kobweb.silk.theme.colors.palette.colorMode

private val SuccessColorLight = Color.rgb(0xCFEBC1)
private val OnSuccessColorLight = Color.rgb(0x364D2E)
private val WarningColorLight = Color.rgb(0xFFDEA8)
private val OnWarningColorLight = Color.rgb(0x5E4200)
private val InfoColorLight = Color.rgb(0xA7C7E7)
private val OnInfoColorLight = Color.rgb(0x001C3B)

private val SuccessColorDark = Color.rgb(0x364D2E)
private val OnSuccessColorDark = Color.rgb(0xCFEBC1)
private val WarningColorDark = Color.rgb(0x5E4200)
private val OnWarningColorDark = Color.rgb(0xFFDEA8)
private val InfoColorDark = Color.rgb(0x001C3B)
private val OnInfoColorDark = Color.rgb(0xA7C7E7)

val ColorMode.SuccessColor get() = if (this == ColorMode.LIGHT) SuccessColorLight else SuccessColorDark
val ColorMode.OnSuccessColor get() = if (this == ColorMode.LIGHT) OnSuccessColorLight else OnSuccessColorDark
val ColorMode.WarningColor get() = if (this == ColorMode.LIGHT) WarningColorLight else WarningColorDark
val ColorMode.OnWarningColor get() = if (this == ColorMode.LIGHT) OnWarningColorLight else OnWarningColorDark
val ColorMode.InfoColor get() = if (this == ColorMode.LIGHT) InfoColorLight else InfoColorDark
val ColorMode.OnInfoColor get() = if (this == ColorMode.LIGHT) OnInfoColorLight else OnInfoColorDark

private val PrimaryLight = Color.rgb(78, 91, 146)
private val OnPrimaryLight = Color.rgb(255, 255, 255)
private val PrimaryContainerLight = Color.rgb(221, 225, 255)
private val OnPrimaryContainerLight = Color.rgb(6, 22, 75)
private val SecondaryLight = Color.rgb(72, 93, 146)
private val OnSecondaryLight = Color.rgb(255, 255, 255)
private val SecondaryContainerLight = Color.rgb(218, 226, 255)
private val OnSecondaryContainerLight = Color.rgb(0, 25, 71)
private val TertiaryLight = Color.rgb(71, 93, 146)
private val OnTertiaryLight = Color.rgb(255, 255, 255)
private val TertiaryContainerLight = Color.rgb(217, 226, 255)
private val OnTertiaryContainerLight = Color.rgb(0, 25, 70)
private val ErrorLight = Color.rgb(186, 26, 26)
private val OnErrorLight = Color.rgb(255, 255, 255)
private val ErrorContainerLight = Color.rgb(255, 218, 214)
private val OnErrorContainerLight = Color.rgb(65, 0, 2)
private val BackgroundLight = Color.rgb(251, 248, 255)
private val OnBackgroundLight = Color.rgb(26, 27, 33)
private val SurfaceLight = Color.rgb(251, 248, 255)
private val OnSurfaceLight = Color.rgb(26, 27, 33)
private val SurfaceVariantLight = Color.rgb(226, 225, 236)
private val OnSurfaceVariantLight = Color.rgb(69, 70, 79)
private val OutlineLight = Color.rgb(118, 118, 128)
private val OutlineVariantLight = Color.rgb(198, 197, 208)
private val ScrimLight = Color.rgb(0, 0, 0)
private val InverseSurfaceLight = Color.rgb(47, 48, 54)
private val InverseOnSurfaceLight = Color.rgb(242, 240, 247)
private val InversePrimaryLight = Color.rgb(183, 196, 255)
private val SurfaceDimLight = Color.rgb(219, 217, 224)
private val SurfaceBrightLight = Color.rgb(251, 248, 255)
private val SurfaceContainerLowestLight = Color.rgb(255, 255, 255)
private val SurfaceContainerLowLight = Color.rgb(244, 242, 250)
private val SurfaceContainerLight = Color.rgb(239, 237, 244)
private val SurfaceContainerHighLight = Color.rgb(233, 231, 239)
private val SurfaceContainerHighestLight = Color.rgb(227, 225, 233)

private val PrimaryDark = Color.rgb(183, 196, 255)
private val OnPrimaryDark = Color.rgb(31, 45, 97)
private val PrimaryContainerDark = Color.rgb(54, 67, 121)
private val OnPrimaryContainerDark = Color.rgb(221, 225, 255)
private val SecondaryDark = Color.rgb(177, 197, 255)
private val OnSecondaryDark = Color.rgb(23, 46, 96)
private val SecondaryContainerDark = Color.rgb(48, 69, 120)
private val OnSecondaryContainerDark = Color.rgb(218, 226, 255)
private val TertiaryDark = Color.rgb(177, 198, 255)
private val OnTertiaryDark = Color.rgb(22, 46, 96)
private val TertiaryContainerDark = Color.rgb(47, 69, 120)
private val OnTertiaryContainerDark = Color.rgb(217, 226, 255)
private val ErrorDark = Color.rgb(255, 180, 171)
private val OnErrorDark = Color.rgb(105, 0, 5)
private val ErrorContainerDark = Color.rgb(147, 0, 10)
private val OnErrorContainerDark = Color.rgb(255, 218, 214)
private val BackgroundDark = Color.rgb(18, 19, 24)
private val OnBackgroundDark = Color.rgb(227, 225, 233)
private val SurfaceDark = Color.rgb(18, 19, 24)
private val OnSurfaceDark = Color.rgb(227, 225, 233)
private val SurfaceVariantDark = Color.rgb(69, 70, 79)
private val OnSurfaceVariantDark = Color.rgb(198, 197, 208)
private val OutlineDark = Color.rgb(144, 144, 154)
private val OutlineVariantDark = Color.rgb(69, 70, 79)
private val ScrimDark = Color.rgb(0, 0, 0)
private val InverseSurfaceDark = Color.rgb(227, 225, 233)
private val InverseOnSurfaceDark = Color.rgb(47, 48, 54)
private val InversePrimaryDark = Color.rgb(78, 91, 146)
private val SurfaceDimDark = Color.rgb(18, 19, 24)
private val SurfaceBrightDark = Color.rgb(56, 57, 63)
private val SurfaceContainerLowestDark = Color.rgb(13, 14, 19)
private val SurfaceContainerLowDark = Color.rgb(26, 27, 33)
private val SurfaceContainerDark = Color.rgb(31, 31, 37)
private val SurfaceContainerHighDark = Color.rgb(41, 42, 47)
private val SurfaceContainerHighestDark = Color.rgb(52, 52, 58)

val CbLightColorScheme = lightColorScheme(
    primary = PrimaryLight,
    onPrimary = OnPrimaryLight,
    primaryContainer = PrimaryContainerLight,
    onPrimaryContainer = OnPrimaryContainerLight,
    secondary = SecondaryLight,
    onSecondary = OnSecondaryLight,
    secondaryContainer = SecondaryContainerLight,
    onSecondaryContainer = OnSecondaryContainerLight,
    tertiary = TertiaryLight,
    onTertiary = OnTertiaryLight,
    tertiaryContainer = TertiaryContainerLight,
    onTertiaryContainer = OnTertiaryContainerLight,
    error = ErrorLight,
    onError = OnErrorLight,
    errorContainer = ErrorContainerLight,
    onErrorContainer = OnErrorContainerLight,
    background = BackgroundLight,
    onBackground = OnBackgroundLight,
    surface = SurfaceLight,
    onSurface = OnSurfaceLight,
    surfaceVariant = SurfaceVariantLight,
    onSurfaceVariant = OnSurfaceVariantLight,
    surfaceTint = PrimaryLight,
    outline = OutlineLight,
    outlineVariant = OutlineVariantLight,
    scrim = ScrimLight,
    inverseSurface = InverseSurfaceLight,
    inverseOnSurface = InverseOnSurfaceLight,
    inversePrimary = InversePrimaryLight,
    surfaceDim = SurfaceDimLight,
    surfaceBright = SurfaceBrightLight,
    surfaceContainerLowest = SurfaceContainerLowestLight,
    surfaceContainerLow = SurfaceContainerLowLight,
    surfaceContainer = SurfaceContainerLight,
    surfaceContainerHigh = SurfaceContainerHighLight,
    surfaceContainerHighest = SurfaceContainerHighestLight,
)

val CbDarkColorScheme = darkColorScheme(
    primary = PrimaryDark,
    onPrimary = OnPrimaryDark,
    primaryContainer = PrimaryContainerDark,
    onPrimaryContainer = OnPrimaryContainerDark,
    secondary = SecondaryDark,
    onSecondary = OnSecondaryDark,
    secondaryContainer = SecondaryContainerDark,
    onSecondaryContainer = OnSecondaryContainerDark,
    tertiary = TertiaryDark,
    onTertiary = OnTertiaryDark,
    tertiaryContainer = TertiaryContainerDark,
    onTertiaryContainer = OnTertiaryContainerDark,
    error = ErrorDark,
    onError = OnErrorDark,
    errorContainer = ErrorContainerDark,
    onErrorContainer = OnErrorContainerDark,
    background = BackgroundDark,
    onBackground = OnBackgroundDark,
    surface = SurfaceDark,
    onSurface = OnSurfaceDark,
    surfaceVariant = SurfaceVariantDark,
    onSurfaceVariant = OnSurfaceVariantDark,
    surfaceTint = PrimaryDark,
    outline = OutlineDark,
    outlineVariant = OutlineVariantDark,
    scrim = ScrimDark,
    inverseSurface = InverseSurfaceDark,
    inverseOnSurface = InverseOnSurfaceDark,
    inversePrimary = InversePrimaryDark,
    surfaceDim = SurfaceDimDark,
    surfaceBright = SurfaceBrightDark,
    surfaceContainerLowest = SurfaceContainerLowestDark,
    surfaceContainerLow = SurfaceContainerLowDark,
    surfaceContainer = SurfaceContainerDark,
    surfaceContainerHigh = SurfaceContainerHighDark,
    surfaceContainerHighest = SurfaceContainerHighestDark,
)
